import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type Theme = 'default' | 'dark' | 'light-simple';

interface UIState {
  theme: Theme;
  isPrivate: boolean;
}

const getInitialState = (): UIState => {
  if (typeof window !== 'undefined') {
    const savedTheme = localStorage.getItem('theme') as Theme;
    const savedIsPrivate = localStorage.getItem('isPrivate') === 'true';
    return {
      theme: savedTheme || 'default',
      isPrivate: savedIsPrivate,
    };
  }
  return {
    theme: 'default',
    isPrivate: false,
  };
};

const uiSlice = createSlice({
  name: 'ui',
  initialState: getInitialState(),
  reducers: {
    setTheme: (state, action: PayloadAction<Theme>) => {
      state.theme = action.payload;
      if (typeof window !== 'undefined') {
        localStorage.setItem('theme', action.payload);
        const root = window.document.documentElement;
        root.classList.remove('dark', 'light-simple');
        if (action.payload !== 'default') {
          root.classList.add(action.payload);
        }
      }
    },
    toggleIsPrivate: (state) => {
      state.isPrivate = !state.isPrivate;
      if (typeof window !== 'undefined') {
        localStorage.setItem('isPrivate', String(state.isPrivate));
      }
    },
    setIsPrivate: (state, action: PayloadAction<boolean>) => {
      state.isPrivate = action.payload;
      if (typeof window !== 'undefined') {
        localStorage.setItem('isPrivate', String(action.payload));
      }
    },
  },
});

export const { setTheme, toggleIsPrivate, setIsPrivate } = uiSlice.actions;
export default uiSlice.reducer;
